/* =========================================================
   BAHARI AQUA - PRODUCT CARD SWATCH IMAGE SWITCHER
   Para: assets/bahari-product-card.js
   Funciona en colecciones / featured collection / product grid
   ========================================================= */

(function () {
  function initBahariProductCard(card) {
    if (!card || card.dataset.bahariCardInitialized === 'true') return;

    var mainImage = card.querySelector('.bahari-product-card__image');
    var swatches = Array.prototype.slice.call(
      card.querySelectorAll('.bahari-product-card__swatch:not(.bahari-product-card__swatch--more)')
    );

    if (!mainImage || !swatches.length) return;

    card.dataset.bahariCardInitialized = 'true';

    var mediaLink = card.querySelector('.bahari-product-card__media-link');
    var titleLink = card.querySelector('.bahari-product-card__title a');

    var original = {
      src: mainImage.getAttribute('src') || '',
      srcset: mainImage.getAttribute('srcset') || '',
      sizes: mainImage.getAttribute('sizes') || '',
      alt: mainImage.getAttribute('alt') || '',
      url: mediaLink ? mediaLink.getAttribute('href') : ''
    };

    var selectedSwatch =
      swatches.find(function (swatch) {
        return swatch.classList.contains('is-active');
      }) || null;

    function getSwatchImage(swatch) {
      if (!swatch) return null;

      var innerImage = swatch.querySelector('img');

      var src =
        swatch.dataset.cardImage ||
        swatch.dataset.image ||
        swatch.dataset.src ||
        swatch.getAttribute('data-card-image') ||
        swatch.getAttribute('data-image') ||
        '';

      var srcset =
        swatch.dataset.cardImageSrcset ||
        swatch.dataset.srcset ||
        swatch.getAttribute('data-card-image-srcset') ||
        swatch.getAttribute('data-srcset') ||
        '';

      var sizes =
        swatch.dataset.cardImageSizes ||
        swatch.dataset.sizes ||
        swatch.getAttribute('data-card-image-sizes') ||
        swatch.getAttribute('data-sizes') ||
        '';

      var alt =
        swatch.dataset.cardImageAlt ||
        swatch.getAttribute('aria-label') ||
        mainImage.getAttribute('alt') ||
        '';

      var url =
        swatch.dataset.cardUrl ||
        swatch.dataset.variantUrl ||
        swatch.getAttribute('href') ||
        '';

      // No usamos la miniatura del swatch como imagen principal,
      // porque se ve borrosa al escalarse.
      if (!src) return null;

      if (!srcset && innerImage) {
        srcset = innerImage.getAttribute('srcset') || '';
      }

      if (!sizes && innerImage) {
        sizes = innerImage.getAttribute('sizes') || '';
      }

      if (!src) return null;

      return {
        src: src,
        srcset: srcset,
        sizes: sizes,
        alt: alt,
        url: url
      };
    }

    function setMainImage(data) {
      if (!data || !data.src) return;

      mainImage.style.opacity = '0.55';

      window.setTimeout(function () {
        if (data.srcset) {
          mainImage.setAttribute('srcset', data.srcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        if (data.sizes) {
          mainImage.setAttribute('sizes', data.sizes);
        }

        mainImage.setAttribute('src', data.src);

        if (data.alt) {
          mainImage.setAttribute('alt', data.alt);
        }

        mainImage.style.opacity = '';
      }, 80);
    }

    function setOriginalImage() {
      if (original.srcset) {
        mainImage.setAttribute('srcset', original.srcset);
      } else {
        mainImage.removeAttribute('srcset');
      }

      if (original.sizes) {
        mainImage.setAttribute('sizes', original.sizes);
      }

      if (original.src) {
        mainImage.setAttribute('src', original.src);
      }

      if (original.alt) {
        mainImage.setAttribute('alt', original.alt);
      }
    }

    function setActiveSwatch(swatch) {
      swatches.forEach(function (item) {
        item.classList.toggle('is-active', item === swatch);
      });
    }

    function updateCardLinks(data) {
      if (!data || !data.url) return;

      if (mediaLink) {
        mediaLink.setAttribute('href', data.url);
      }

      if (titleLink) {
        titleLink.setAttribute('href', data.url);
      }
    }

    function previewSwatch(swatch) {
      var data = getSwatchImage(swatch);
      if (!data) return;

      setMainImage(data);
    }

    function selectSwatch(swatch) {
      var data = getSwatchImage(swatch);
      if (!data) return;

      selectedSwatch = swatch;

      setActiveSwatch(swatch);
      setMainImage(data);
      updateCardLinks(data);
    }

    function restoreSelectedImage() {
      if (selectedSwatch) {
        var data = getSwatchImage(selectedSwatch);

        if (data) {
          setMainImage(data);
          return;
        }
      }

      setOriginalImage();
    }

    swatches.forEach(function (swatch) {
      var data = getSwatchImage(swatch);

      if (data && data.src) {
        var preload = new Image();
        preload.src = data.src;
      }

      swatch.addEventListener('mouseenter', function () {
        previewSwatch(swatch);
      });

      swatch.addEventListener('focus', function () {
        previewSwatch(swatch);
      });

      swatch.addEventListener('mouseleave', function () {
        restoreSelectedImage();
      });

      swatch.addEventListener('blur', function () {
        restoreSelectedImage();
      });

      swatch.addEventListener('click', function (event) {
        if (swatch.classList.contains('bahari-product-card__swatch--more')) return;

        event.preventDefault();
        selectSwatch(swatch);
      });

      swatch.addEventListener('touchstart', function () {
        selectSwatch(swatch);
      }, { passive: true });
    });

    if (selectedSwatch) {
      selectSwatch(selectedSwatch);
    }
  }

  function initAllBahariProductCards(root) {
    var scope = root || document;

    scope.querySelectorAll('.bahari-product-card').forEach(function (card) {
      initBahariProductCard(card);
    });
  }

  function boot() {
    initAllBahariProductCards(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllBahariProductCards(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAllBahariProductCards(event.target);
  });

  document.addEventListener('facets:rendered', function () {
    initAllBahariProductCards(document);
  });

  var productGrid = document.getElementById('ProductGridContainer');

  if (productGrid && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      initAllBahariProductCards(productGrid);
    });

    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }

  window.BahariProductCardsInit = initAllBahariProductCards;
})();